import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";

export default {
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  [MUTATIONS.ON_NOTIFICATION_TOAST]: (state, payload) => {
    Vue.set(state, "notificationToast", payload);
  },
  [MUTATIONS.ON_NOTIFICATION_MODAL]: (state, payload) => {
    Vue.set(state, "notificationModal", payload);
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_PASO_1]: (state, payload) => {
    Vue.set(state, "paso1", payload);
  },
  [MUTATIONS.ON_PASO_2]: (state, payload) => {
    Vue.set(state, "paso2", payload);
  },
  [MUTATIONS.ON_PASO_3]: (state, payload) => {
    Vue.set(state, "paso3", payload);
  },
  [MUTATIONS.ON_GRACIAS]: (state, payload) => {
    Vue.set(state, "gracias", payload);
  },
  [MUTATIONS.ON_CONDICION]: (state, payload) => {
    Vue.set(state, "consulta", payload);
  },
  [MUTATIONS.ON_FORZAR_DNE]: (state, force) => {
    Vue.set(state, "forzarDNE", Object.assign({}, state.forzarDNE, force));
  },
  [MUTATIONS.ON_ERROR_MERLIN]: (state, force) => {
    Vue.set(state, "merlin", Object.assign({}, state.merlin, force));
  },
  [MUTATIONS.ON_ERROR]: (state, payload) => {
    Vue.set(state, "error", payload);
  },
  [MUTATIONS.ON_CONSULTA_DATOS_PATENTE]: (state, payload) => {
    Vue.set(state, "consulta", payload);
  },
  [MUTATIONS.ON_LIMPIAR_DATOS_PATENTE]: (state, payload) => {
    const newPayload = {
      ...payload,
      condicion: "S",
      gnc: "",
      marca: "1",
      modelo: "",
      version: ""
    };
    Vue.set(state, "consulta", newPayload);
  },
  [MUTATIONS.ON_CONSULTA_MARCAS_AUTO]: (state, payload) => {
    Vue.set(state, "marcasAuto", payload);
  },
  [MUTATIONS.ON_CONSULTA_MODELOS_AUTO]: (state, payload) => {
    Vue.set(state, "modelosAuto", payload);
  },
  [MUTATIONS.ON_CONSULTA_VERSION_AUTO]: (state, payload) => {
    Vue.set(state, "versionesAuto", payload);
  },
  [MUTATIONS.ON_CONSULTA_SIMULACION_COTIZACION]: (state, payload) => {
    Vue.set(state, "resultadosCotizacion", payload);
  },
  [MUTATIONS.ADOBE_INTERNAL_LINK]: () => {},
  [MUTATIONS.ADOBE_APP_STARTED]: (state, payload) => {
    Vue.set(state, "trackOnClickStart", payload);
  },
  [MUTATIONS.ADOBE_APP_ON_CLICK_START]: () => {},
  [MUTATIONS.ADOBE_MODAL]: () => {},
  [MUTATIONS.ON_CONSULTA_VIVIENDA]: (state, payload) => {
    const firstElement = {
      codigoInmueble: "",
      descripcion: "",
      tipoColaTS: ""
    };
    state.tiposDeVivienda = [firstElement].concat(payload);
  },
  [MUTATIONS.ON_COTIZACION_HOGAR]: (state, payload) => {
    state.cotizacionHogar = payload;
  },
  [MUTATIONS.ON_RECOTIZACION_HOGAR]: (state, payload) => {
    state.cotizacionHogar = payload;
  },
  [MUTATIONS.ON_GUARDAR_DESCRIPCION_VIVIENDA]: (state, payload) => {
    state.paso1Hogar.viviendaDescripcion = payload;
  },
  [MUTATIONS.ON_COBERTURA_ANADIR]: (state, payload) => {
    state.coberturasAnadidas.push(payload);
  },
  [MUTATIONS.ON_COBERTURA_QUITAR]: (state, payload) => {
    state.coberturasAnadidas = payload;
  },
  [MUTATIONS.ON_COBERTURA_QUITAR_TODAS]: state => {
    state.coberturasAnadidas = [];
  },
  [MUTATIONS.ON_COBERTURAS_SELECCIONADAS]: (state, payload) => {
    state.coberturasSeleccionadas = payload;
  },
  [MUTATIONS.ON_LIMPIAR_DATOS_PASO1HOGAR]: state => {
    let payload = {
      metros: "",
      vivienda: "",
      codigoPostal: ""
    };
    Vue.set(state, "paso1Hogar", payload);
  },
  [MUTATIONS.ON_OBTENER_PDF_HOGAR]: (state, payload) => {
    state.pdf = payload;
  },
  [MUTATIONS.ON_NORMALIZAR_CELULAR]: (state, payload) => {
    const newCelularNormalizado = {
      ...state.celularNormalizado,
      normalizado: payload
    };
    state.celularNormalizado = newCelularNormalizado;
  },
  [MUTATIONS.ADOBE_QUIERO_QUE_ME_CONTACTEN]: () => {},
  [MUTATIONS.ON_USER_ID_TOKENIZADO]: (state, payload) => {
    state.userIdTokenizado = payload;
  }
};
